/**
 * Get Compliance Use Case
 * Fetches a single compliance with proofs
 */

import { TenantComplianceEntity, ComplianceProofEntity } from "../../entities";
import { TenantComplianceRepository } from "../../repositories";

export class GetComplianceUseCase {
  constructor(private repository: TenantComplianceRepository) {}

  async execute(
    id: number
  ): Promise<TenantComplianceEntity & { proofs: ComplianceProofEntity[] }> {
    return await this.repository.getCompliance(id);
  }
}

